/* Bureaulift — site complet : en-tête, tiroir panier (Ajax Cart Shopify), accordéons, animations.
   Tout passe par la délégation d'événements pour survivre aux rechargements de sections dans l'éditeur. */
(function () {
  if (window.__blsSite) return;
  window.__blsSite = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $all = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- En-tête : ombre au défilement + menu mobile ---------- */
  function onScroll(e) {
    var t = e && e.target && e.target !== document ? e.target : document.scrollingElement;
    if (!t || (t !== document.scrollingElement && !(t.classList && t.classList.contains('page-wrapper')))) return;
    var sc = (t.scrollTop || window.scrollY || 0) > 40;
    $all('.bls-header').forEach(function (h) { h.classList.toggle('is-scrolled', sc); });
  }
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-bls-burger]');
    if (burger) {
      var h = burger.closest('.bls-header');
      var open = !h.classList.contains('is-nav-open');
      h.classList.toggle('is-nav-open', open);
      burger.setAttribute('aria-expanded', String(open));
    }
  });

  /* ---------- Accordéons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bls-acc-btn]');
    if (!btn) return;
    var item = btn.closest('[data-bls-acc-item]');
    var group = btn.closest('[data-bls-acc]');
    var open = !item.classList.contains('is-open');
    if (group && group.dataset.blsAcc === 'single') {
      $all('[data-bls-acc-item].is-open', group).forEach(function (o) { if (o !== item) { o.classList.remove('is-open'); var b = o.querySelector('[data-bls-acc-btn]'); if (b) b.setAttribute('aria-expanded', 'false'); } });
    }
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
  });

  /* ---------- Panier : compteur + tiroir ---------- */
  function setCount(n) {
    $all('[data-bl-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function drawer() { return document.querySelector('[data-bls-cd]'); }
  function openDrawer() {
    var d = drawer();
    if (!d) return false;
    d.classList.add('is-open');
    d.querySelector('.bls-cd').setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bls-lock');
    return true;
  }
  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.querySelector('.bls-cd').setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bls-lock');
  }
  function swapDrawer(html) {
    var d = drawer();
    if (!d || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-bls-cd-inner]');
    var cur = d.querySelector('[data-bls-cd-inner]');
    if (fresh && cur) cur.replaceWith(fresh);
  }
  function sectionId() { var d = drawer(); return d ? d.dataset.sectionId : null; }
  function afterCart(cart, sections) {
    if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
    var id = sectionId();
    if (sections && id && sections[id]) swapDrawer(sections[id]);
    document.dispatchEvent(new CustomEvent('bls:cart-updated', { detail: cart }));
  }
  function refresh() {
    var id = sectionId();
    var reqs = [fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })];
    if (id) reqs.push(fetch(root + '?sections=' + encodeURIComponent(id)).then(function (r) { return r.json(); }).catch(function () { return null; }));
    return Promise.all(reqs).then(function (res) { afterCart(res[0], res[1]); return res[0]; });
  }
  function change(key, qty) {
    var d = drawer();
    var box = d && d.querySelector('.bls-cd');
    if (box) box.classList.add('is-busy');
    var body = { id: key, quantity: qty };
    var id = sectionId();
    if (id) { body.sections = [id]; body.sections_url = location.pathname; }
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function (cart) { afterCart(cart, cart.sections); })
      .catch(function () { return refresh(); })
      .then(function () { var b = drawer() && drawer().querySelector('.bls-cd'); if (b) b.classList.remove('is-busy'); });
  }
  window.BLSCart = { open: openDrawer, close: closeDrawer, refresh: refresh, change: change };

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-bls-cart-open]');
    if (opener && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-bls-cd-close]')) { e.preventDefault(); closeDrawer(); return; }
    var q = t.closest('[data-bls-qty]');
    if (q) { e.preventDefault(); change(q.dataset.key, Math.max(0, Number(q.dataset.qty))); return; }
    var ti = t.closest('[data-bls-ti]');
    if (ti) {
      var wrap = ti.closest('.bls-cd__trustwrap, [data-bls-trustwrap]');
      var pop = wrap.querySelector('[data-bls-tipop]');
      var active = ti.classList.contains('is-active');
      $all('[data-bls-ti]', wrap).forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-expanded', 'false'); });
      if (active) { pop.hidden = true; return; }
      ti.classList.add('is-active');
      ti.setAttribute('aria-expanded', 'true');
      pop.querySelector('b').textContent = ti.dataset.title;
      pop.querySelector('span').textContent = ti.dataset.detail;
      pop.hidden = false;
      return;
    }
    var tc = t.closest('[data-bls-tipop-close]');
    if (tc) {
      var w = tc.closest('.bls-cd__trustwrap, [data-bls-trustwrap]');
      w.querySelector('[data-bls-tipop]').hidden = true;
      $all('[data-bls-ti]', w).forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-expanded', 'false'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  /* Ajout depuis la fiche produit (bureaulift.js émet bl:cart-added) */
  document.addEventListener('bl:cart-added', function () { refresh().then(openDrawer); });

  /* ---------- Animations d'apparition ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) return;
  var EASE = 'cubic-bezier(.2,.7,.2,1)';
  function hide(el, delay) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity .7s ease ' + delay + 'ms, transform .8s ' + EASE + ' ' + delay + 'ms';
  }
  function show(items) {
    items.forEach(function (c) { c.style.opacity = '1'; c.style.transform = 'translateY(0)'; });
    setTimeout(function () { items.forEach(function (c) { c.style.transition = ''; c.style.transform = ''; c.style.opacity = ''; }); }, 1600);
  }
  function collect(el) {
    var items = [el];
    $all('[data-reveal-stagger]', el).forEach(function (g) {
      Array.prototype.slice.call(g.children).forEach(function (c, i) { items.push(c); c.__blDelay = 140 + i * 90; });
    });
    return items;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      show(e.target.__blItems || [e.target]);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  function prep(el) {
    if (el.__bl) return;
    el.__bl = 1;
    if (el.hasAttribute('data-reveal-load')) {
      var kids = Array.prototype.slice.call(el.children);
      kids.forEach(function (c, i) { hide(c, 60 + i * 90); });
      requestAnimationFrame(function () { requestAnimationFrame(function () { show(kids); }); });
      return;
    }
    if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
    var items = collect(el);
    items.forEach(function (c) { hide(c, c.__blDelay || 0); });
    el.__blItems = items;
    io.observe(el);
  }
  function scan(r) { $all('[data-reveal],[data-reveal-load]', r).forEach(prep); }
  function start() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ---------- Fiche produit : description « Lire plus » + visionneuse plein écran des images ---------- */
(function () {
  if (window.__blsProduct) return;
  window.__blsProduct = true;
  var $all = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* Lire plus : bouton masqué si le texte est plus court que la hauteur visible */
  function rmCheck(rm) {
    var body = rm.querySelector('[data-bls-rm-body]');
    if (!body || rm.classList.contains('is-open') || !body.offsetParent) return;
    var limit = parseFloat(getComputedStyle(rm).getPropertyValue('--bls-rm-h')) || 220;
    rm.classList.toggle('is-short', body.scrollHeight <= limit + 24);
  }
  function rmAll() { $all('[data-bls-rm]').forEach(rmCheck); }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bls-rm-btn]');
    if (btn) {
      var rm = btn.closest('[data-bls-rm]');
      var open = !rm.classList.contains('is-open');
      rm.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      btn.querySelector('[data-bls-rm-label]').textContent = open ? btn.dataset.less : btn.dataset.more;
      if (!open) { var top = rm.getBoundingClientRect().top; if (top < 0) rm.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
      return;
    }
    if (e.target.closest('.bl-acc__btn')) setTimeout(rmAll, 60);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rmAll); else rmAll();
  window.addEventListener('load', rmAll);
  window.addEventListener('resize', rmAll);

  /* Visionneuse */
  function bigSrc(img) {
    var best = img.currentSrc || img.src, bw = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
      var p = part.trim().split(/\s+/);
      var w = parseInt(p[1], 10) || 0;
      if (p[0] && w > bw) { bw = w; best = p[0]; }
    });
    return best;
  }
  var lb = null, cur = 0, items = [];
  function build() {
    lb = document.createElement('div');
    lb.className = 'bl bls-zlb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="bls-zlb__top"><span class="bls-zlb__count" data-z-count></span><button type="button" class="bls-zlb__x" data-z-close aria-label="Fermer">×</button></div>' +
      '<div class="bls-zlb__track" data-z-track></div>' +
      '<button type="button" class="bls-zlb__nav bls-zlb__nav--prev" data-z-prev aria-label="Image précédente">‹</button>' +
      '<button type="button" class="bls-zlb__nav bls-zlb__nav--next" data-z-next aria-label="Image suivante">›</button>' +
      '<div class="bls-zlb__thumbs" data-z-thumbs></div>';
    document.body.appendChild(lb);
    lb.querySelector('[data-z-track]').addEventListener('scroll', function () {
      var t = this, i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
      if (i !== cur) { cur = i; mark(); }
    }, { passive: true });
  }
  function mark() {
    lb.querySelector('[data-z-count]').textContent = (cur + 1) + ' / ' + items.length;
    $all('[data-z-thumb]', lb).forEach(function (t, k) { t.classList.toggle('is-active', k === cur); if (k === cur && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center' }); });
    lb.querySelector('[data-z-prev]').style.visibility = cur > 0 ? '' : 'hidden';
    lb.querySelector('[data-z-next]').style.visibility = cur < items.length - 1 ? '' : 'hidden';
  }
  function go(i, smooth) {
    var t = lb.querySelector('[data-z-track]');
    cur = Math.max(0, Math.min(items.length - 1, i));
    t.scrollTo({ left: cur * t.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    mark();
  }
  function open(list, i) {
    if (!lb) build();
    items = list;
    var track = lb.querySelector('[data-z-track]'), thumbs = lb.querySelector('[data-z-thumbs]');
    track.innerHTML = items.map(function (it) { return '<div class="bls-zlb__slide"><img src="' + it.src + '" alt="' + (it.alt || '').replace(/"/g, '&quot;') + '" loading="lazy" decoding="async"></div>'; }).join('');
    thumbs.innerHTML = items.length > 1 ? items.map(function (it, k) { return '<button type="button" class="bls-zlb__thumb" data-z-thumb="' + k + '" aria-label="Image ' + (k + 1) + '"><img src="' + it.thumb + '" alt=""></button>'; }).join('') : '';
    lb.hidden = false;
    document.documentElement.classList.add('bls-lock');
    requestAnimationFrame(function () { go(i, false); });
    lb.querySelector('[data-z-close]').focus({ preventScroll: true });
  }
  function close() { if (!lb) return; lb.hidden = true; document.documentElement.classList.remove('bls-lock'); }

  document.addEventListener('click', function (e) {
    if (lb && !lb.hidden && lb.contains(e.target)) {
      if (e.target.closest('[data-z-close]')) return close();
      if (e.target.closest('[data-z-prev]')) return go(cur - 1, true);
      if (e.target.closest('[data-z-next]')) return go(cur + 1, true);
      var th = e.target.closest('[data-z-thumb]');
      if (th) return go(Number(th.dataset.zThumb), true);
      if (e.target.classList.contains('bls-zlb__slide')) return close();
      return;
    }
    var img = e.target.closest('[data-bl-slide] img, .bl-bcar img');
    if (!img || e.target.closest('a')) return;
    var group = img.closest('[data-bl-gal-stage]') || img.closest('[data-bl-bcar]');
    if (!group) return;
    var seen = {}, list = [], idx = 0;
    $all(group.matches('[data-bl-gal-stage]') ? '[data-bl-slide] img' : 'img', group).forEach(function (im) {
      var src = bigSrc(im), key = src.split('?')[0].replace(/_\d+x\d*(?=\.)/, '');
      if (seen[key] !== undefined) { if (im === img) idx = seen[key]; return; }
      seen[key] = list.length;
      if (im === img) idx = list.length;
      list.push({ src: src, thumb: im.currentSrc || im.src, alt: im.alt });
    });
    if (list.length) open(list, idx);
  });
  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(cur - 1, true);
    else if (e.key === 'ArrowRight') go(cur + 1, true);
  });
  window.addEventListener('resize', function () { if (lb && !lb.hidden) go(cur, false); });
})();

/* ---------- Note (étoiles) cliquable : défilement doux jusqu'au bloc d'avis (app Trustoo ou section du thème) ---------- */
(function () {
  if (window.__blsReviewsLink) return;
  window.__blsReviewsLink = true;
  function find(sel) {
    var parts = (sel || '#trustoo-widget-wrapper, #vstar-reviews, [data-bl-reviews]').split(',');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (!p) continue;
      try { var el = document.querySelector(p); if (el && el.offsetHeight > 0) return el; } catch (err) {}
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bl-reviews-link]');
    if (!a) return;
    e.preventDefault();
    var go = function (tries) {
      var el = find(a.dataset.target);
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (tries > 0) { setTimeout(function () { go(tries - 1); }, 300); return; }
      var main = document.getElementById('MainContent');
      if (main) main.lastElementChild && main.lastElementChild.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    go(6);
  });
})();

/* ---------- Avis (Trustoo) : le widget injecté par l'app est déplacé dans la section « BLS · Avis clients » ---------- */
(function () {
  if (window.__blsReviewsSlot) return;
  window.__blsReviewsSlot = true;
  function place() {
    var slot = document.querySelector('[data-bl-reviews-slot]');
    if (!slot) return false;
    var sel = slot.dataset.selector || '#trustoo-widget-wrapper';
    var w = null;
    try { w = document.querySelector(sel); } catch (e) { return false; }
    if (!w) return false;
    if (w.parentElement !== slot) slot.appendChild(w);
    slot.classList.add('is-filled');
    return true;
  }
  function start() {
    if (!document.querySelector('[data-bl-reviews-slot]')) return;
    place();
    var mo = new MutationObserver(function () { place(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { place(); });
})();
